import React, { Component } from 'react';
import { connect } from 'react-redux';
import ShopListListItem from './shop_list_list_item';
import _ from 'lodash';
import '../css/common.css';
import '../css/main.css';

var evenrow = true;

class ShopListList extends Component {

  componentDidMount() {

  }

  shopListItems() {
    return _.map(this.props.shopList, shopList => {
      evenrow = !evenrow;
      return (
        <ShopListListItem onShopListSelect={this.props.onShopListSelect} key={shopList.Key} shopList={shopList} evenrow={evenrow}/>
      );
    });
  }

  render() {
    return (
      <ul id="recipe-list" className="no-bullet-ul">
        {this.shopListItems()}
      </ul>
    );
  }
};

function mapStateToProps(state) {
  return { shopList: state.shop_lists.shop_list_list };
}

export default connect(mapStateToProps)(ShopListList);



// WEBPACK FOOTER //
// ./src/components/shop_list_list.js